'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'umbrella-beach';
var width = 512;
var height = 512;
var aliases = [127958];
var unicode = 'f5ca';
var svgPathData = ['M96.4 122.6l362.1 181c3.6-15.3 5.5-31.2 5.5-47.6 0-114.9-93.1-208-208-208-64 0-121.4 28.9-159.6 74.6z', 'M464 256c0 16.4-1.9 32.3-5.5 47.6L96.4 122.6C134.6 76.9 192 48 256 48 370.9 48 464 141.1 464 256zm-7.6 100.2c15.8 7.9 35.2 1.5 41.1-15.1 9.4-26.6 14.5-55.3 14.5-85.1 0-141.4-114.6-256-256-256-88.8 0-167 45.2-212.9 113.8-9.8 14.7-3.3 34.1 12.5 42l172.5 86.3-1.6 3.2-109.4 218.7-93.2 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-317.2 0 98.6-197.3 1.6-3.2 185.4 92.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUmbrellaBeach = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;